import {
  GetInvoiceSummaryInCSV,
  GetInvoiceSummaryResponse,
  GetProjects,
  GetSentInvoices,
  InvoiceSummaryProps,
} from '../../../../types/Invoicing/InvoiceSummary/invoiceSummaryType'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, InvoiceSummaryApiConfig } from '../../apiList'

const getProjects = async (): Promise<GetProjects[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoiceSummaryApiConfig.getProjects,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getInvoiceSummary = async (
  props: InvoiceSummaryProps,
): Promise<GetInvoiceSummaryResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoiceSummaryApiConfig.getInvoiceSummary,
    method: AllowedHttpMethods.get,
    params: {
      clientId: props.clientId,
      projectId: props.projectId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const getSentInvoices = async (
  summaryId: number,
): Promise<GetSentInvoices[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoiceSummaryApiConfig.getSentInvoices,
    method: AllowedHttpMethods.get,
    params: {
      summaryId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const ExportInvoiceSummaryDownloading = async (
  props: GetInvoiceSummaryInCSV,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoiceSummaryApiConfig.getInvoiceSummaryInCSV,
    method: AllowedHttpMethods.get,
    params: {
      projectId: props.projectId,
      clientId: props.clientId,
      token: localStorage.getItem('token') ?? '',
    },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const invoiceSummaryApi = {
  getProjects,
  getInvoiceSummary,
  getSentInvoices,
  ExportInvoiceSummaryDownloading,
}
export default invoiceSummaryApi
